// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1HEOf","newExpiryDate":"styles_newExpiryDate__1Sopk","footer":"styles_footer__wW11a"};